import type { TransformedNoContentOption } from '@flows/core/types/stepContentTypes'
import { MINIMUM_CUSTOMER_AGE } from '@flows/insurance/constants'
import { BaseSchema_TravelHealthV1BerlinDirektDe as schema } from '@flows/insurance/schemas'

export const TRAVEL_HEALTH_PREMIUM_INTERVAL = 'P1Y'

const tariffTypes = schema.shape.tariff_type.options
const relationshipTypes =
  schema.shape.insured_family_members.unwrap().element.shape.relationship_type.options

export const TRAVEL_HEALTH_NXT_CONSTANTS: {
  tariffTypeOptions: TransformedNoContentOption[]
  relationshipTypeOptions: TransformedNoContentOption[]
  MINIMUM_AGE: number
  MAXIMUM_AGE: number
  MAXIMUM_FAMILY_MEMBERS: number
} = {
  tariffTypeOptions: tariffTypes.map((option) => ({
    label: {
      type: 'translatableText',
      translationKey: `sharedFlows_travelHealth:steps.tariff_selection.options.${option}`,
    },
    value: option,
  })),
  relationshipTypeOptions: relationshipTypes.map((option) => ({
    label: {
      type: 'translatableText',
      translationKey: `sharedFlows_travelHealth:steps.family_members.relationship.${option}`,
    },
    value: option,
  })),
  MINIMUM_AGE: MINIMUM_CUSTOMER_AGE.de,
  MAXIMUM_AGE: 66,
  MAXIMUM_FAMILY_MEMBERS: 7,
}
